import { Component, OnInit, inject } from '@angular/core';
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs';
import { UserService } from '@origin8-web/core-ui/login/providers';
import { UserStore } from '../core/store/user/user.store';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Layout } from './layout/layout.component';

@Component({
  selector: 'arc-root',
  templateUrl: './app.component.html',
  imports: [Toast, ConfirmDialog, Layout],
  providers: [MessageService, ConfirmationService],
})
export class AppComponent implements OnInit {
  readonly title = 'arc-client';
  readonly userStore = inject(UserStore);
  private readonly userService = inject(UserService);
  private readonly userInfoUpdate = this.userService.getIsLoggedIn$().pipe(
    takeUntilDestroyed(),
    filter((loggedIn) => !!loggedIn),
    switchMap(() => this.userService.getUser$()),
    distinctUntilChanged(),
    tap((userInfo) => {
      this.userStore.setUserInfo(userInfo);
    }),
  );

  ngOnInit(): void {
    this.userInfoUpdate.subscribe();
  }
}
